import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=5f31002b&scoped=true&"
import script from "./AppLogo.vue?vue&type=script&lang=ts&"
export * from "./AppLogo.vue?vue&type=script&lang=ts&"
import style0 from "./AppLogo.vue?vue&type=style&index=0&id=5f31002b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f31002b",
  null
  
)

export default component.exports